import { rgbToHsl,hexToRgb } from './utilities.js';

const DARK1 = { BG: '#101018', A: '#333393', B: '#6D6D86' };
const DARK3 = { BG: '#ac833e', A: '#4a8a7c', B: '#516a8d' };
const LIGHT1 = { BG: '#5c566b', A: '#eb9b11', B: '#baaed6' };
const DARK2 = { BG: '#1c1413', A: '#6e1a21', B: '#77758a' };
const BW1 = { BG: '#FFFFFF', B: '#ADADAD', A: '#696969' };
const BW2 = { BG: '#4E4F4F', B: '#696969', A: '#ADADAD' };

const THEME = DARK1;

export const BACKGROUND_COLOR = THEME.BG;
export const COLOR_A = THEME.A;
export const COLOR_B = THEME.B;
export const COLOR_A_HSL=rgbToHsl(THEME.A);
export const COLOR_B_HSL=rgbToHsl(THEME.B);

export const COLOR_A_RGB=hexToRgb(THEME.A);
export const COLOR_B_RGB=hexToRgb(THEME.B);



export const FONT_COLOR = THEME.B;
export const TEXTURE_A = { im: 'dark-fish-skin.png', w: 2 };
export const TEXTURE_B = { im: 'dark-fish-skin.png', w: 2 };

document.documentElement.style.setProperty('--texture_a', TEXTURE_A.im);
document.documentElement.style.setProperty('--bg_color', BACKGROUND_COLOR);
document.documentElement.style.setProperty('--font_color', FONT_COLOR);

document.documentElement.style.setProperty('--color_a', COLOR_A);

document.documentElement.style.setProperty('--color_b', COLOR_B);

// #101018 #333393 #6D6D86
